"use client";
import { motion } from "framer-motion";
import { Linkedin, Instagram, Facebook } from "lucide-react";
import logo from "../assets/Marca MAYMA.png";

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <img
              src={logo}
              alt="Mayma"
              className="h-16 w-auto mb-4 rounded-md bg-white"
            />
            <p className="text-gray-600 mb-4 leading-relaxed">
              Soluciones de software empresarial que transforman organizaciones
              y generan valor real.
            </p>
            <div className="flex space-x-4">
              {[
                {
                  icon: Linkedin,
                  url: "https://www.linkedin.com/in/maymaSistemas",
                },
                {
                  icon: Facebook,
                  url: "https://www.facebook.com/maymaSistemas",
                },
                {
                  icon: Instagram,
                  url: "https://www.instagram.com/maymaSistemas",
                },
              ].map(({ icon: Icon, url }, index) => (
                <motion.a
                  key={index}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.1 }}
                  className="text-gray-500 hover:text-[#77c593] transition-colors"
                >
                  <Icon size={20} />
                </motion.a>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h3 className="text-gray-900 font-semibold mb-4">Servicios</h3>
            <ul className="space-y-2 text-gray-600">
              <li>
                <a
                  href="#servicios"
                  className="hover:text-[#77c593] transition-colors"
                >
                  Desarrollo de Software
                </a>
              </li>
              <li>
                <a
                  href="#servicios"
                  className="hover:text-[#77c593] transition-colors"
                >
                  Soluciones Móviles
                </a>
              </li>
              <li>
                <a
                  href="#servicios"
                  className="hover:text-[#77c593] transition-colors"
                >
                  Automatización de Procesos
                </a>
              </li>
              <li>
                <a
                  href="#servicios"
                  className="hover:text-[#77c593] transition-colors"
                >
                  Consultoría Técnica
                </a>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h3 className="text-gray-900 font-semibold mb-4">Empresa</h3>
            <ul className="space-y-2 text-gray-600">
              <li>
                <a
                  href="#nosotros"
                  className="hover:text-[#77c593] transition-colors"
                >
                  Sobre Nosotros
                </a>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <h3 className="text-gray-900 font-semibold mb-4">Contacto</h3>
            <ul className="space-y-2 text-gray-600">
              <li>Gualeguaychú, Entre Ríos, Argentina.</li>
              <li>+54 9 3446 21-4708</li>
              <li>consultas@mayma.ar</li>
              <li>Lun - Vie: 9:00 - 18:00</li>
            </ul>
          </motion.div>
        </div>

        {/* <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">
            &copy; {new Date().getFullYear()} Mayma. Todos los derechos
            reservados.{" "}
          </p>
        </div> */}
        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-2 text-sm text-gray-600">
          <p>
            &copy; {new Date().getFullYear()} Mayma. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-4">
            <a href="/terminos-y-condiciones" target="_blank" className="hover:underline">
              Términos y condiciones
            </a>
            <a href="/politica-de-privacidad" target="_blank" className="hover:underline">
              Política de privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
